"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableVerticalSeparation = void 0;
var tslib_1 = require("tslib");
var __1 = require("../..");
var theme_1 = require("../../../draw/theme");
var id_1 = require("../../../id");
var unit_1 = require("../../../unit");
var drawable_1 = require("./drawable");
/**
 * Draw a vertical separation annotation with a label and an optional minimum distance check.
 */
var CollectionModelDrawableVerticalSeparation = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableVerticalSeparation, _super);
    function CollectionModelDrawableVerticalSeparation(collectionModelDrawableState, topMarkerId, bottomMarkerId, fieldId, label, drawableId) {
        if (drawableId === void 0) { drawableId = id_1.IkeId.generate(); }
        var _this = _super.call(this, collectionModelDrawableState, drawableId) || this;
        _this._topMarkerId = topMarkerId;
        _this._bottomMarkerId = bottomMarkerId;
        _this._fieldId = fieldId;
        _this._label = label;
        return _this;
    }
    CollectionModelDrawableVerticalSeparation.createWithLabel = function (drawableState, topMarkerId, bottomMarkerId, fieldId) {
        var id = id_1.IkeId.generate();
        var label = new __1.CollectionModelDrawableLabel(drawableState, "".concat(id, ":label"), 0, 0, id);
        var drawable = new CollectionModelDrawableVerticalSeparation(drawableState, topMarkerId, bottomMarkerId, fieldId, label, id);
        drawable.moveLabelToDefaultPosition();
        return drawable;
    };
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "label", {
        get: function () {
            return this._label;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableVerticalSeparation.prototype.getLabelConnectionPoint = function (options) {
        return this.getLabelConnectionPointForSide(this.label.isOnLeftSide(), options.draw.state.zoom);
    };
    /**
     * Pass leftSide = true for left, or leftSide = false for right.
     */
    CollectionModelDrawableVerticalSeparation.prototype.getLabelConnectionPointForSide = function (leftSide, zoom) {
        if (zoom === void 0) { zoom = 1; }
        var indexOffset = this.indexInGroupWithSameTopMarker() * theme_1.StyleConfig.STROKE_WIDTH * 4;
        var markerOffsetWidth = 200 - zoom * 10;
        return {
            // If label is on left side, draw line to middle of vertical separation on the left side of the pole.
            // Otherwise, draw to middle of the separation on the right side of the pole.
            x: leftSide
                ? (this.topMarker.x - markerOffsetWidth + indexOffset)
                : (this.topMarker.x + markerOffsetWidth - indexOffset),
            y: this.topMarker.y + (this.distanceBetweenMarkersInPixels + theme_1.StyleConfig.STROKE_WIDTH) / 2
        };
    };
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "topMarker", {
        get: function () {
            return this.drawableState.getDrawable(this._topMarkerId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "bottomMarker", {
        get: function () {
            return this.drawableState.getDrawable(this._bottomMarkerId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "topMarkerId", {
        get: function () {
            return this._topMarkerId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "bottomMarkerId", {
        get: function () {
            return this._bottomMarkerId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "distanceBetweenMarkersInPixels", {
        get: function () {
            return this.bottomMarker.y - this.topMarker.y;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "distanceBetweenMarkersInMeters", {
        get: function () {
            return this.drawableState.collection.state.getGeometry(this.drawableState.captureId).calculateDistance(this.bottomMarker.getVector(), this.topMarker.getVector());
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableVerticalSeparation.prototype.verticalSeparationsWithSameTopMarker = function () {
        var e_1, _a;
        var result = [];
        try {
            for (var _b = tslib_1.__values(this.drawableState.getAllDrawables()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var drawable = _c.value;
                if (!(drawable instanceof CollectionModelDrawableVerticalSeparation)) {
                    continue;
                }
                if (drawable.topMarkerId !== this.topMarkerId) {
                    continue;
                }
                result.push(drawable);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        result.sort(function (a, b) { var _a, _b; return ((_a = a.field.value) !== null && _a !== void 0 ? _a : 0) - ((_b = b.field.value) !== null && _b !== void 0 ? _b : 0); });
        return result;
    };
    /**
     * Returns the index of this vertical separation in the list of vertical separations
     * that have the same top marker, when ordered by field value (distance between top and bottom markers).
     */
    CollectionModelDrawableVerticalSeparation.prototype.indexInGroupWithSameTopMarker = function () {
        return this.verticalSeparationsWithSameTopMarker().indexOf(this);
    };
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "fieldId", {
        get: function () {
            return this._fieldId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "field", {
        get: function () {
            return this.collection.getFieldDeep(this._fieldId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "clearanceThresholdInMeters", {
        get: function () {
            return this.field.schema.clearanceThresholdInMeters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "isInClearance", {
        /**
         * Returns true if the distance between the top and bottom markers is greater than the clearance defined on the form field.
         * If a clearance is not defined on the form field, it returns undefined.
         */
        get: function () {
            if (!this.clearanceThresholdInMeters) {
                return undefined;
            }
            return this.distanceBetweenMarkersInMeters > this.clearanceThresholdInMeters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "text", {
        /**
         * @deprecated Use {@link getLabelDisplayText} instead.
         */
        get: function () {
            return this.field.schema.displayName;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableVerticalSeparation.prototype.getLabelDisplayText = function (options) {
        // The distance between the markers formatted as a distance string (e.g. 66" or 52cm).
        var clearanceText = unit_1.IkeUnit.display(this.distanceBetweenMarkersInMeters, options.units === 'meters' ? unit_1.IkeUnit.CENTIMETER : unit_1.IkeUnit.INCH, undefined, undefined, 0);
        if (!this.clearanceThresholdInMeters) {
            return [clearanceText + ' - ' + this.field.schema.displayName];
        }
        return [(this.isInClearance ? '✅ ' : '❌ ') + clearanceText + ' - ' + this.field.schema.displayName];
    };
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "x", {
        get: function () {
            return this.topMarker.x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "y", {
        get: function () {
            return this.topMarker.y;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableVerticalSeparation.prototype.moveLabelToDefaultPosition = function () {
        this.label.snapToLeftSide();
        this.label.move(this.label.x, this.getLabelConnectionPointForSide(true, 1).y);
    };
    CollectionModelDrawableVerticalSeparation.prototype.remove = function () {
        _super.prototype.remove.call(this);
        // Remove the label too, unless it has already been removed
        if (this.drawableState.hasDrawable(this._label.id)) {
            this.label.remove();
        }
    };
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "isInsightMeasurement", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableVerticalSeparation.prototype.isApprovableInsightDrawable = function () {
        return false;
    };
    Object.defineProperty(CollectionModelDrawableVerticalSeparation.prototype, "isVisible", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableVerticalSeparation.prototype.clone = function (newParentDrawableState) {
        if (!newParentDrawableState.hasDrawable(this._label.id)) {
            this.label.clone(newParentDrawableState);
        }
        return new CollectionModelDrawableVerticalSeparation(newParentDrawableState, this._topMarkerId, this._bottomMarkerId, this._fieldId, newParentDrawableState.getDrawable(this.label.id), this.id);
    };
    CollectionModelDrawableVerticalSeparation.prototype.equals = function (other) {
        return (other instanceof CollectionModelDrawableVerticalSeparation
            && this._topMarkerId === other._topMarkerId
            && this._bottomMarkerId === other._bottomMarkerId
            && this._fieldId === other._fieldId
            && this._equals(other));
    };
    return CollectionModelDrawableVerticalSeparation;
}(drawable_1.CollectionModelDrawable));
exports.CollectionModelDrawableVerticalSeparation = CollectionModelDrawableVerticalSeparation;
//# sourceMappingURL=vertical.separation.drawable.js.map